import { Component, OnInit, Input, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable, fromEvent, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { SetupService } from '@core/services/setup';
import { HomeService } from '../../home.service';

@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
})
export class HeroComponent implements OnInit {
    /*
     * heroFullWidth - controla comportamento do hero
     */
    heroFullWidth: boolean = window.innerWidth < 992;

    heroTemplate: TemplateRef<any>;

    @ViewChild('banner') template01: TemplateRef<any>;
    @ViewChild('carouselOverlay') template02: TemplateRef<any>;
    @ViewChild('carousel') template03: TemplateRef<any>;

    height = '470px';

    /**
     * sliders: instancia de array de sliders
     */
    sliders: any[] = [];

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno de dados da API, coleção das recentes notícias
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];
    loaded: boolean = false;

    constructor(
        private homeService: HomeService,
        public setupService: SetupService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.lastNews();
        this.changeHeroBasedOnScreenSize();
    }

    ngAfterViewInit() {
        this.defineTemplate();
        this.cdRef.detectChanges();
    }

    defineTemplate() {
        switch (this.setupService.components?.newsBlock) {
            case '1':
                this.heroTemplate = this.template01;
                break;
            case '2':
                this.heroTemplate = this.template03;
                break;
            case '3':
                this.heroTemplate = this.template03;
                break;
            default:
                this.heroTemplate = this.template01;
                break;
        }
    }

    /**
     * lastNews() - Buscar últimias notícias publicadas
     */
    lastNews() {
        this.homeService.getSliders().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        if (this.statusCode == 0) {
            for (let i = 0; i < this.registers.length; i++) {
                const image = this.registers[i]['images'][0]['slider'];

                this.sliders.push({
                    ...this.registers[i],
                    image,
                });
            }
        }
        this.loaded = true;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    /**
     * debouncedResizeListener - adiciona escuta de resize da tela
     * com debounce
     * @return {Observable}
     */
    debouncedResizeListener(): Observable<any> {
        return fromEvent(window, 'resize').pipe(debounce(() => interval(1500)));
    }

    /**
     * changeHeroBasedOnScreenSize - muda comportamento do hero
     * de acordo com tamanho da tela
     * @return void
     */
    changeHeroBasedOnScreenSize() {
        this.debouncedResizeListener().subscribe(() => {
            if (window.innerWidth < 992) {
                this.heroFullWidth = true;
            } else {
                this.heroFullWidth = false;
            }
        });
    }
}
